import { render } from "./ProductModal.vue?vue&type=template&id=2f823fa4&scoped=true"
import script from "./ProductModal.vue?vue&type=script&lang=js"
export * from "./ProductModal.vue?vue&type=script&lang=js"

import "./ProductModal.vue?vue&type=style&index=0&id=2f823fa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f823fa4"],['__file',"src/components/ProductModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f823fa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f823fa4', __exports__)) {
    api.reload('2f823fa4', __exports__)
  }
  
  module.hot.accept("./ProductModal.vue?vue&type=template&id=2f823fa4&scoped=true", () => {
    api.rerender('2f823fa4', render)
  })

}


export default __exports__